import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=26f0a482&"
import script from "./eventDetail.ts?vue&type=script&lang=ts&"
export * from "./eventDetail.ts?vue&type=script&lang=ts&"
import style0 from "./eventDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports